<template>
  <el-tooltip :content="attr.value" placement="top-end" effect="light">
    <!-- content to trigger tooltip here -->
    <div class="attr-item" :class="{actived, disable}" @click="onClick">
      <img v-if="showImg" class="w-8 h-8" :src="joinHead(attr.src)" alt="">
      <template v-else>
        {{ attr.value }}
      </template>
    </div>
  </el-tooltip>

</template>

<script>
export default {
  props: {
    attr: {
      type: Object,
      default() {
        return {}
      }
    },

    showImg: {
      type: Boolean,
      default: false
    },

    actived: {
      type: Boolean,
      default: false
    },

    disable: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onClick() {
      if (!this.disable) {
        this.$emit('click')
      }
    }
  }
}
</script>

<style lang="scss" scoped>.attr-item {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
  border-radius: 0.125rem;
  cursor: pointer;
  line-height: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.attr-item:hover, .attr-item.actived {
  --tw-bg-opacity: 1;
  background-color: rgba(216, 16, 16, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.attr-item.disable {
  cursor: not-allowed;
  opacity: 0.6;
}</style>
